export default __webpack_public_path__ + "static/media/project-status-confirmation-rejected.d992e0a8.svg";